import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Slider from 'react-slick';

import useMedia from '~hooks/useMedia';

import { SLICK_SETTING } from './constants';
import * as S from './style';

export default function BannerText() {
  const { isMobile } = useMedia();

  if (isMobile) {
    return (
      <S.Wrapper>
        <div style={{ display: 'flex' }}>
          <span>궁금했던</span>
          <Slider {...SLICK_SETTING}>
            <span>기업</span>
            <span>연봉</span>
            <span>채용</span>
          </Slider>
          <span>정보,</span>
        </div>
        <span>크레딧잡에서</span>
      </S.Wrapper>
    );
  }

  return (
    <S.Wrapper>
      <span>궁금했던</span>
      <Slider {...SLICK_SETTING}>
        <span>기업</span>
        <span>연봉</span>
        <span>채용</span>
      </Slider>
      <span>정보, 크레딧잡에서</span>
    </S.Wrapper>
  );
}
